import type {
  GetAgPrice,
  PriceWithBlockMappings
} from '@epilot/journey-logic-commons'
import type { Currency, TimeFrequency } from '@epilot/pricing'
import type { TFunction } from 'i18next'
import { createContext, useContext } from 'react'

type PriceGetAgDetailsContextType = {
  item: PriceWithBlockMappings
  getAgPriceDetails: GetAgPrice
  userLocale: string
  currency: Currency
  billingPeriod: TimeFrequency
  unit?: string
  getAgPriceType: 'power' | 'gas'
  tax?: number
  t: TFunction
}

export const PriceGetAgDetailsContext = createContext<
  PriceGetAgDetailsContextType | undefined
>(undefined)

type PriceGetAgDetailsProviderProps = {
  children: React.ReactNode
  value: PriceGetAgDetailsContextType
}

export const PriceGetAgDetailsProvider = ({
  children,
  value
}: PriceGetAgDetailsProviderProps) => {
  return (
    <PriceGetAgDetailsContext.Provider value={value}>
      {children}
    </PriceGetAgDetailsContext.Provider>
  )
}

export const usePriceGetAgDetailsContext = () => {
  const context = useContext(PriceGetAgDetailsContext)

  if (context === undefined) {
    throw new Error(
      'usePriceGetAgDetailsContext must be used within a PriceGetAgDetailsProvider'
    )
  }

  return context
}
